import { useState } from "react";
import { accountService } from "@miplatform/api";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { AccountType } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

export const usePlansViewModel = () => {
  const [accounts, setAccounts] = useState([]);
  const [recentAccounts, setRecentAccounts] = useState([]);
  const [search, setSearch] = useState("");

  const debouncedSearch = useDebounce(search, 300);
  const stateManager = useComponentState();
  const GET_ACCOUNTS_UUID = createUUID();
  const GET_RECENT_ACCOUNTS_UUID = createUUID();

  const getAccounts = ({ top, skip }) => {
    stateManager.abort(GET_ACCOUNTS_UUID);
    return stateManager.run(() => {
      return accountService.accounts.getAll({
        sort: "name",
        filters: {
          accountType: AccountType.Builder,
          or: [
            { name: { contains: debouncedSearch } },
            { code: { contains: debouncedSearch } },
          ],
        },
        top,
        skip,
      });
    }, GET_ACCOUNTS_UUID);
  };

  const getRecentAccounts = ({ sort, filters, top }) => {
    stateManager.abort(GET_RECENT_ACCOUNTS_UUID);
    return stateManager.run(async () => {
      return accountService.accounts.getAll({ sort, filters, top });
    }, GET_RECENT_ACCOUNTS_UUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    accounts,
    search,
    debouncedSearch,
    setSearch,
    setAccounts,
    getAccounts,
    getRecentAccounts,
    setRecentAccounts,
    recentAccounts,
  };
};
